import Markdown from "markdown-to-jsx";
import Image from 'next/image'
import styles from "./proposito.module.css";


export default function Descricao({ data }) {
  return (
    <section className={`container-full ${styles.container}`}>
      <div
        className={`flex-column-reverse align-items-center align-items-lg-start flex-lg-row ${styles.content}`}
      >
        <div className={styles.descricao}>
          <Markdown>{data.texto}</Markdown>
        </div>
        <div className={styles.image_desc}>
          <Image 
            src={data.imagem.url}
            width={851}
            height={510}
            alt="imagem pai e filho"
            objectFit="contain"
            reponsive
          />
        </div>
      </div>
    </section>
  );
}
